module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as2504-c7ff0d10087b2c1c96fdc1d35b283825.jpg";